//custom js
jQuery(function($){
  var locationData = JSON.parse($('#locationMenuJSON').html());
  $(document).on('click', '.region-selector', function(){
    var region = $(this).data('value');
    var optionsHtml = '';
    var firstStoreUrl = false;
    var initialVal = $(this).parents('.selector-wrapper').siblings('.selector-wrapper').find('.editable-select').data('initial-value');
    var count = 0;
    $(this).parent().siblings('input').val(region);
    $.each(locationData[region], function(index, value){
      count += 1;
      var selected_string = "";
      var initial_value = value[0];
      if(Object.keys(locationData[region]).length > 1) initial_value = initialVal.toUpperCase();
      if(count == 1) {
        firstStoreUrl = value[1];
        if(Object.keys(locationData[region]).length > 1) firstStoreUrl = '#';
        $('.store-selector').parent().siblings('input').val(initial_value);
        //selected_string = " selected";
      }
      optionsHtml += '<li class="store-selector" data-value="'+index+'"'+selected_string+'>'+value[0]+'</li>';
    });
    $('.store-selector').parent().html(optionsHtml);
    $('.store-button').attr('href', firstStoreUrl);
    $(this).parent().hide();
  });
  $(document).on('click', '.store-selector', function(){
    var region = $('.region-selector-input').val();
    var store = $(this).data('value');
    var storeUrl = locationData[region][store][1];
    $(this).parent().siblings('input').val(store);
    $('.store-button').attr('href', storeUrl);
    $(this).parent().hide();
  });
  $(document).on('click', 'input.select-input', function(){
    $(this).next().find('li').show();
    $(this).next().toggle();
    $(this).parents('.selector-wrapper').siblings('.selector-wrapper').find('.editable-select').hide();
  });
  $(document).on('keyup', 'input.select-input', function(){
    var subString = $(this).val().toLowerCase();
    $(this).next().find('li').each(function(){
      if($(this).data('value').toLowerCase().indexOf(subString) > -1){
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
  $(document).on('mouseleave', '.selector-wrapper', function(){
    $('.editable-select').hide();
  });
  $(document).on('click', '.location-area a[href="#"]', function(e){
    e.preventDefault();
    alert($('.store-selector-input').siblings('ul').data('initial-value'));
  });
});



